import type { InvariantJiraRoute } from '@jira/platform__routing-route-types/src/InvariantJiraRoute.tsx';

export const assetsForYouRoute: InvariantJiraRoute = {
	name: 'assets-for-you',
	path: '/jira/assets/for-you',
	exact: true,
};
